import { Grid } from "@material-ui/core";
import { makeStyles, Theme } from '@material-ui/core/styles';
import { observer } from "mobx-react";
import { useClosingScheduleStore } from "../hooks/useClosingScheduleStore";
import { CLOSING_LOANS_COLUMNS } from "./closingLoansColumns";
import { ClosingAgreedLoansGridV2 } from "./closingAgreedLoansGridV2";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    minHeight: '750px',
  },
}))

export const ClosingNextBusinessDayGrid = observer(() => {
  const classes = useStyles();
  const { closingScheduleStore } = useClosingScheduleStore();

  return (
    <Grid container className={classes.container}>
      <ClosingAgreedLoansGridV2
        columns={CLOSING_LOANS_COLUMNS}
        store={closingScheduleStore.closingNextBusinessDayGridStore}
      />
    </Grid>
  )
})
